import { render, staticRenderFns } from "./NoServiceAvailable.vue?vue&type=template&id=e98e9fe8"
import script from "./NoServiceAvailable.vue?vue&type=script&lang=js"
export * from "./NoServiceAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports